import { ROUTE_NAMES as BUYBACK } from '~/scopes/buyback/constants'
import { CHECKOUT } from '~/scopes/checkout/routes-names'
import { CMS } from '~/scopes/cms/routes-names'
import { ROUTE_NAMES as DASHBOARD_ROUTE_NAMES } from '~/scopes/dashboard/constants'
import { HOME } from '~/scopes/home/route-names'
import { ROUTES as PLP } from '~/scopes/product-list/route-names'
import { ROUTES as RECYCLING } from '~/scopes/recycling/routes-names'

import translations from './AppStoreDownloadBanner.translations'
import type { BannerConfig } from './AppStoreDownloadBanner.types'

const defaultBannerConfig = {
  title: translations.appStoreDownloadBannerDefaultTitle,
  mobileTitle: translations.appStoreDownloadBannerDefaultMobileTitle,
  subtitle: translations.appStoreDownloadBannerDefaultSubtitle,
  qrCodePath:
    '/img/lead-collection/appDownload/default-app-download-qr-code.svg',
  mobileTrackedUrl:
    'https://app.backmarket.com/Mlqg?af_xp=custom&pid=Website&c=GLO_ALL_WEB_Mobile_download-app_popup_button&af_dp=backmarket://start/home&deep_link_value=start/home',
}

const productListConfig = {
  title: translations.appStoreDownloadBannerProductListTitle,
  mobileTitle: translations.appStoreDownloadBannerProductListMobileTitle,
  subtitle: translations.appStoreDownloadBannerProductListSubtitle,
  qrCodePath:
    '/img/lead-collection/appDownload/product-list-app-download-qr-code.svg',
  mobileTrackedUrl:
    'https://app.backmarket.com/Mlqg?af_xp=custom&pid=Website&c=GLO_ALL_WEB_Mobile_Pop-up-PLP_Buttons&deep_link_value=start/shop&af_dp=backmarket://start/shop',
}

export const bannerConfig: BannerConfig = {
  [HOME]: defaultBannerConfig,
  [CMS.EVENT]: defaultBannerConfig,
  [CMS.ARTICLE_HUB]: defaultBannerConfig,
  [CMS.ARTICLE_ROOT_HUB]: defaultBannerConfig,
  [PLP.PRODUCT_LIST]: productListConfig,
  [PLP.UNIVERSE]: productListConfig,
  [CHECKOUT.PAYMENT_RESULT]: {
    title: translations.appStoreDownloadBannerPaymentConfirmationTitle,
    subtitle: translations.appStoreDownloadBannerPaymentConfirmationSubtitle,
    qrCodePath:
      '/img/lead-collection/appDownload/payment-confirmation-app-download-qr-code.svg',
    desktopTrackedUrl:
      'https://app.backmarket.com/Mlqg?af_xp=custom&pid=Website&c=GLO_ALL_WEB_Desktop_Payment-Success_Buttons&af_dp=backmarket://orders&deep_link_value=orders',
    mobileTrackedUrl:
      'https://app.backmarket.com/Mlqg?af_xp=custom&pid=Website&c=GLO_ALL_WEB_Mobile_Payment-Success_Buttons&af_dp=backmarket://orders&deep_link_value=orders',
  },
  [DASHBOARD_ROUTE_NAMES.DASHBOARD.FAVORITES]: {
    title: translations.appStoreDownloadBannerFavoritesTitle,
    qrCodePath:
      '/img/lead-collection/appDownload/favorites-app-download-qr-code.svg',
    desktopTrackedUrl:
      'https://app.backmarket.com/Mlqg?af_xp=custom&pid=Website&c=GLO_ALL_WEB_Desktop_Favorites_Buttons&deep_link_value=favorites&deep_link_sub1=backmarket://start/home&af_dp=backmarket://start/home',
    mobileTrackedUrl:
      'https://app.backmarket.com/Mlqg?af_xp=custom&pid=Website&c=GLO_ALL_WEB_Mobile_Favorites_Buttons&deep_link_value=favorites&deep_link_sub1=backmarket://start/home&af_dp=backmarket://start/home',
  },
  [CMS.BUYBACK]: {
    title: translations.appStoreDownloadBannerBuybackTitle,
    mobileTitle: translations.appStoreDownloadBannerBuybackMobileTitle,
    subtitle: translations.appStoreDownloadBannerBuybackSubtitle,
    qrCodePath:
      '/img/lead-collection/appDownload/trade-in-app-download-qr-code.svg',
    mobileTrackedUrl:
      'https://app.backmarket.com/Mlqg?af_xp=custom&pid=Website&c=GLO_ALL_WEB_Mobile_Tradein-Home_Buttons&af_dp=backmarket://buyback/home&deep_link_value=buyback/home',
  },
  [BUYBACK.CONFIRMATION]: {
    title: translations.appStoreDownloadBannerTradeInConfirmationTitle,
    subtitle: translations.appStoreDownloadBannerTradeInConfirmationSubtitle,
    qrCodePath:
      '/img/lead-collection/appDownload/trade-in-confirmation-app-download-qr-code.svg',
    desktopTrackedUrl:
      'https://app.backmarket.com/Mlqg?af_xp=custom&pid=Website&c=GLO_ALL_WEB_Desktop_Tradein-Confirmation_Buttons&af_dp=backmarket://buyback/mySales&deep_link_value=buyback/mySales',
    mobileTrackedUrl:
      'https://app.backmarket.com/Mlqg?af_xp=custom&pid=Website&c=GLO_ALL_WEB_Mobile_Tradein-Confirmation_Buttons&af_dp=backmarket://buyback/home&deep_link_value=buyback/home',
  },
  [RECYCLING.OFFER]: defaultBannerConfig,
} as const
